import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

const ACTION_OBJECT_NAME = 'WRITING_ASSIGNMENT_COMMENT';
export const SUBMIT_WRITING_ASSIGNMENT_COMMENT_REQUEST = `SUBMIT_${ACTION_OBJECT_NAME}_REQUEST`;
export const SUBMIT_WRITING_ASSIGNMENT_COMMENT_SUCCESS = `SUBMIT_${ACTION_OBJECT_NAME}_SUCCESS`;
export const SUBMIT_WRITING_ASSIGNMENT_COMMENT_FAILURE = `SUBMIT_${ACTION_OBJECT_NAME}_FAILURE`;

export const submitWritingAssignmmentComment = (id, payload) => (dispatch) => {
  const url = buildUrl(`/writing-assignment-activities/${id}/essay-remarks`);
  const method = 'PUT';
  return dispatch(submitWritingAssignmmentCommentRequest()).payload
    .then((response) => dispatch(submitWritingAssignmmentCommentSuccess(response)))
    .catch((error) => dispatch(submitWritingAssignmmentCommentFailure(error)));

  function submitWritingAssignmmentCommentRequest() {
    const request = fetch(url,
      {
        method,
        body: JSON.stringify(payload),
      }
    );
    return ApiCall.createAction({
      type: SUBMIT_WRITING_ASSIGNMENT_COMMENT_REQUEST,
      payload: request,
      url,
      method,
    });
  }

  function submitWritingAssignmmentCommentSuccess() {
    return ApiCall.createAction({
      type: SUBMIT_WRITING_ASSIGNMENT_COMMENT_SUCCESS,
      url,
      method,
    });
  }

  function submitWritingAssignmmentCommentFailure(error) {
    return ApiCall.createAction({
      type: SUBMIT_WRITING_ASSIGNMENT_COMMENT_FAILURE,
      url,
      method,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./data/WritingAssignment/Comments/actions.js